module.exports = __webpack_public_path__ + "static/media/ViewPointStill.8579ce94.jpg";